import type { FaireProductEntity } from "../../entity_types/product";

export const p_ek47rqcx2d: FaireProductEntity = {
  token: "p_ek47rqcx2d",
  type: "product",
  name: "14k Gold Diamond Half Eternity Ring, Stackable Ring",
  brandToken: "b_tk6ffkngnw",
  brandName: "PureYou Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/703b0acb650c9a50d501186925555a04c88c783f0e66bef9df221026985a4fdd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/888283579fcbcd1edaf824f8ce28305b25e4e84dd163fa72c197971171a80daa.png",
    "https://cdn.faire.com/fastly/80861eee9f04dc7f4b06654e21104beb7a8e9d75bfa6ab51ea7bfe51adab54d8.png",
    "https://cdn.faire.com/fastly/8da960ab854ad4fc7efb6751ccc71bd303cacdd68c15cd4f036b7ca9220171e7.png",
    "https://cdn.faire.com/fastly/1d41e51962530218896ffc89b425e65233d23db021e3b259c62fb3500b57749f.png",
    "https://cdn.faire.com/fastly/bcb4448b8177ce9e49fdc453f64911eea0ae3b8ad12fb832d0117ed1189e09e9.png",
    "https://cdn.faire.com/fastly/54fc8be06235645486711e15f6e4e8b0709ceff6404f31330a1c2da7819d48fc.png",
    "https://cdn.faire.com/fastly/9b316a72f4eb5c213732a055116e9e615b6f7157655ec6a27be3f0d42dab40d7.png",
    "https://cdn.faire.com/fastly/0bbdb5373eed2a42e3b8c6222e97196719bb8fd1192550f6de31bd13422a9608.png",
    "https://cdn.faire.com/fastly/7bd90641396c5b08434693bab030363eeb1702d7114206d1d5783e931b5b695f.png",
    "https://cdn.faire.com/fastly/6433988b70600780db50f5f862deef4620862336e7010e511e2c74df1bdd8975.png",
    "https://cdn.faire.com/fastly/ed63e628c3a4a5f7e0aee4ee7be6b4995138f4082d83aaf197e2e181cbff8e5f.png",
    "https://cdn.faire.com/fastly/f4ca232186cb1235f796ab0b48865e92f6880c8430d8af270f21afa4075536bf.png",
    "https://cdn.faire.com/fastly/fa10438f59fe29ad6616a552ba22be11b366b0ad31372ed9b07f4b23794126a2.png",
    "https://cdn.faire.com/fastly/08c143ff7916a547603ee26b4e3ad39dcee5d48c266c4fb02bb60c074b9645f2.png",
  ],
  priceDollars: 11420.8,
  description:
    "Metal Details :\nMetal Option: 14k, 18k Stamped Solid Gold \nAvailable in: Yellow Gold, White Gold, Rose Gold\nStone Shape: Oval\nDiamond Carat Weight: 2.19ctw\nWidth:3.5mm\nColor: G-H\nCut: Excellent\nClarity: VS1/SI\n\nRing Sizes range from 3-12 US. If you have any questions about sizing, please do not hesitate to reach out!\n\nLab-Diamond Variation Link - https://www.faire.com/product/p_t69mehf6ch",
  tags: [],
  msrpDollars: 22841.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:44:43.995Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
